import {Provider} from "react-redux";
import createCache from "@emotion/cache";
import {CacheProvider, ThemeProvider} from "@emotion/react";
import {GoogleOAuthProvider} from "@react-oauth/google";

import {PromptProvider} from "@pg-design/prompt-module";
import {DSThemeProvider, IThemeGH, IThemeKM, IThemeRP} from "@pg-design/themes";
import {WeglotContextProvider} from "@pg-mono/i18n";
import {UserDeviceProvider} from "@pg-mono/user-device";

import {GOOGLE_OAUTH_CLIENT_ID} from "@/features/auth/utils/social_auth_config";
import {Notifications} from "@/features/notifications/components/Notifications";
import {AmplitudeUserTracker} from "@/features/tracking/amplitude/AmplitudeUserTracker";
import {useMatchedTheme} from "@/hooks/use_matched_theme";
import {useSessionTracking} from "@/hooks/use_session_tracking";
import {store} from "@/store/store";

import {AuthenticationRouting} from "./routes/AuthenticationRouting";
import {isDevelopment, weglotApiKey} from "./utils/read_environment_variables";

import "@/styles/layers.css";

const emotionCache = createCache({key: "km"});

declare module "@emotion/react" {
    export interface Theme extends IThemeGH, IThemeKM, IThemeRP {}
}

export const App = () => {
    const theme = useMatchedTheme();

    useSessionTracking();

    return (
        <Provider store={store}>
            <CacheProvider value={emotionCache}>
                <DSThemeProvider>
                    <ThemeProvider theme={theme}>
                        <PromptProvider>
                            <UserDeviceProvider userAgent={navigator.userAgent}>
                                <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
                                    <WeglotContextProvider
                                        apiKey={weglotApiKey}
                                        excludedTranslationBlocks={[{value: "#offers-panel-region"}, {value: ".bt"}]}
                                        isDevelopment={isDevelopment}
                                    >
                                        <AmplitudeUserTracker />
                                        <Notifications />
                                        <AuthenticationRouting />
                                    </WeglotContextProvider>
                                </GoogleOAuthProvider>
                            </UserDeviceProvider>
                        </PromptProvider>
                    </ThemeProvider>
                </DSThemeProvider>
            </CacheProvider>
        </Provider>
    );
};
import {Provider} from "react-redux";
import createCache from "@emotion/cache";
import {CacheProvider, ThemeProvider} from "@emotion/react";
import {GoogleOAuthProvider} from "@react-oauth/google";

import {PromptProvider} from "@pg-design/prompt-module";
import {DSThemeProvider, IThemeGH, IThemeKM, IThemeRP} from "@pg-design/themes";
import {WeglotContextProvider} from "@pg-mono/i18n";
import {UserDeviceProvider} from "@pg-mono/user-device";

import {GOOGLE_OAUTH_CLIENT_ID} from "@/features/auth/utils/social_auth_config";
import {Notifications} from "@/features/notifications/components/Notifications";
import {AmplitudeUserTracker} from "@/features/tracking/amplitude/AmplitudeUserTracker";
import {useMatchedTheme} from "@/hooks/use_matched_theme";
import {useSessionTracking} from "@/hooks/use_session_tracking";
import {store} from "@/store/store";

import {AuthenticationRouting} from "./routes/AuthenticationRouting";
import {isDevelopment, weglotApiKey} from "./utils/read_environment_variables";

import "@/styles/layers.css";

const emotionCache = createCache({key: "km"});

declare module "@emotion/react" {
    export interface Theme extends IThemeGH, IThemeKM, IThemeRP {}
}

export const App = () => {
    const theme = useMatchedTheme();

    useSessionTracking();

    return (
        <Provider store={store}>
            <CacheProvider value={emotionCache}>
                <DSThemeProvider>
                    <ThemeProvider theme={theme}>
                        <PromptProvider>
                            <UserDeviceProvider userAgent={navigator.userAgent}>
                                <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
                                    <WeglotContextProvider
                                        apiKey={weglotApiKey}
                                        excludedTranslationBlocks={[{value: "#offers-panel-region"}, {value: ".bt"}]}
                                        isDevelopment={isDevelopment}
                                    >
                                        <AmplitudeUserTracker />
                                        <Notifications />
                                        <AuthenticationRouting />
                                    </WeglotContextProvider>
                                </GoogleOAuthProvider>
                            </UserDeviceProvider>
                        </PromptProvider>
                    </ThemeProvider>
                </DSThemeProvider>
            </CacheProvider>
        </Provider>
    );
};
